// extracted by mini-css-extract-plugin
export default {"ratingContainer":"AddReview_ratingContainer__acBu-","addReviewForm":"AddReview_addReviewForm__wJPVm"};